import { useContext } from 'react';

import { useParams } from 'react-router-dom';

import { useManagementTranslations } from '../../../../Context/crowdfunding/hooks';
import { PeerTypes } from '../../../../api';
import { PeerContext } from './PeerContext';

const usePeerName = () => {
  const ctx = useContext(PeerContext);
  const { peerType, prizeType } = ctx || {};
  const { peer_type } = useParams<{ peer_type: PeerTypes }>();

  const _peer_type = peerType ?? peer_type;

  const { t } = useManagementTranslations();

  const peerName = {
    singular: _peer_type === 'teams' || prizeType === 'team' ? t('team') : t('participant'),
    plural: _peer_type === 'teams' || prizeType === 'participant' ? t('teams') : t('participants'),
  };
  return {
    peerName,
    peer_type: _peer_type,
  };
};

export { usePeerName };
